import { useRouteError } from 'react-router-dom'
import { ErrorState } from '../components/ui/States'
export default function ErrorPage() {
  return (
    <main id="main-content" className="status-page">
      <ErrorState error={useRouteError()} />
    </main>
  )
}
